module.exports = __webpack_public_path__ + "img/icon_mall.818bd9b9.png";